<script>
export default {
  props: {
    hasPax: {
      type: Boolean,
    },
    paxType: {
      type: String,
      default: null,
    },
    seatBlock: {
      type: Boolean,
      default: false,
    },
    seatBlockType: {
      type: String,
      default: null,
    },
    showAttributes: {
      type: Boolean,
      default: false,
    },
    seatAttributes: {
      type: String,
      default: null,
    },
    seatRow: {
      type: Number,
      required: true,
    },
    seatColumn: {
      type: String,
      required: true,
    },
    selectedSeat: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      allowedAttributes: ['h', 'i', 'u', 'n'],
    }
  },
  computed: {
    isSelected() {
      return this.selectedSeat === `${this.seatRow}${this.seatColumn}`
    },
  },
  methods: {
    writeAttributes(a) {
      let returnAttributes = ''
      const attributesArray = a.split()
      attributesArray.forEach((_attribute) => {
        if (this.allowedAttributes.indexOf(_attribute) > 0) {
          returnAttributes = returnAttributes + _attribute
        }
      })
      return returnAttributes
    },
    selectSeat(row, col) {
      const payload = `${row}${col}`
      this.$emit('selectSeat', payload)
    },
    getPaxClass(type) {
      if (!type) return null
      switch (type) {
        case 'CKD':
          return 'pax-is-ckd'
        case 'BRD':
          return 'pax-is-brd'
      }
    },
    getBlockClass(type, string) {
      if (!type) return null
      switch (type) {
        case 'HB' || 'HBX':
          return 'hard' + string
        case 'SB' || 'SBX':
          return 'soft' + string
        case 'P':
          return 'pre-assigned' + string
        case 'PX':
          return 'pre-assigned' + string
        default:
          window.console.error('Unable to seat block type: ', type)
          break
      }
    },
  },
}
</script>

<template>
  <div
    class="isSeat"
    :class="isSelected ? 'selected' : ''"
    @click="selectSeat(seatRow, seatColumn)"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 77.59 72.83"
      :class="getBlockClass(seatBlockType, '-block')"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="192.48"
          y1="518.75"
          x2="265.31"
          y2="518.75"
          gradientTransform="translate(557.58 -192.48) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#516174" />
          <stop offset="0.24" stop-color="#516174" />
          <stop offset="0.5" stop-color="#516174" />
          <stop offset="0.77" stop-color="#28374b" />
          <stop offset="0.87" stop-color="#28374b" />
        </linearGradient>

        <linearGradient
          id="linear-gradient-selected"
          x1="192.48"
          y1="518.75"
          x2="265.31"
          y2="518.75"
          gradientTransform="translate(557.58 -192.48) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#00a1ab" />
          <stop offset="0.24" stop-color="#00a1ab" />
          <stop offset="0.5" stop-color="#00a1ab" />
          <stop offset="0.77" stop-color="#00878f" />
          <stop offset="0.87" stop-color="#00878f" />
        </linearGradient>

        <linearGradient
          id="linear-gradient-hard"
          x1="192.48"
          y1="518.75"
          x2="265.31"
          y2="518.75"
          gradientTransform="translate(557.58 -192.48) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#d10000" />
          <stop offset="0.21" stop-color="#cc0100" />
          <stop offset="0.45" stop-color="#bf0500" />
          <stop offset="0.69" stop-color="#a90a00" />
          <stop offset="0.87" stop-color="#941000" />
        </linearGradient>
      </defs>

      <rect class="cls-1" y="55.61" width="77.59" height="12.22" rx="1.63" />
      <path
        class="cls-2"
        :class="[
          getBlockClass(seatBlockType, '-block'),
          isSelected ? 'show-seat-selected' : '',
        ]"
        d="M56.1,72.83A11.87,11.87,0,0,0,68,61V11.84A11.88,11.88,0,0,0,56.1,0H21.56A11.88,11.88,0,0,0,9.7,11.84V61A11.87,11.87,0,0,0,21.56,72.83Z"
      />
      <path
        class="cls-3"
        :class="[
          getBlockClass(seatBlockType, '-top'),
          isSelected ? 'selected' : '',
        ]"
        d="M68,61V58.47H9.7V61A11.87,11.87,0,0,0,21.56,72.83H56.1A11.87,11.87,0,0,0,68,61Z"
      />
      <path
        class="cls-4"
        d="M77.59,13.58a3.26,3.26,0,0,0-3.26-3.24h-3.1A3.27,3.27,0,0,0,68,13.58V58.47h9.62Z"
      />
      <path
        class="cls-4"
        d="M9.7,13.58a3.26,3.26,0,0,0-3.26-3.24H3.33A3.26,3.26,0,0,0,.08,13.58V58.47H9.7Z"
      />
      <path
        class="cls-5"
        d="M53.93,59.25A3.26,3.26,0,0,0,50.67,56H27a3.26,3.26,0,0,0-3.25,3.25v8.42a2.16,2.16,0,0,0,2.15,2.16H51.77a2.16,2.16,0,0,0,2.16-2.16Z"
      />
      <circle
        v-if="hasPax && !showAttributes"
        class="cls-6"
        :class="[getPaxClass(paxType)]"
        cx="39.01"
        cy="29.24"
        r="14.79"
      />
      <path
        v-if="seatBlock && !showAttributes"
        :class="[getBlockClass(seatBlockType, '')]"
        class="cls-6"
        d="M35.41,29.24l-16-16A2.55,2.55,0,0,1,23,9.61l16,16,16-16a2.55,2.55,0,0,1,3.6,3.6l-16,16,16,16a2.55,2.55,0,0,1-3.6,3.6l-16-16-16,16a2.55,2.55,0,1,1-3.6-3.6l16-16Z"
      />
    </svg>
    <span v-if="showAttributes && seatAttributes" class="seatAttr">
      {{
      writeAttributes(seatAttributes)
      }}
    </span>
    <!-- <span v-if="isSelected" class="seatLetter">{{ seatRow }}{{ seatColumn }}</span> -->
  </div>
</template>

<style>
.pax-is-ckd {
  fill: #fff !important;
  fill: #03d5f4 !important;
  fill: #fff507 !important;
  opacity: 1 !important;
}
.pax-is-brd {
  fill: #77ff77 !important;
  opacity: 1 !important;
}
.cls-1 {
  fill: #8e98a6;
}

.cls-2 {
  fill: #516174;
  fill: url(#linear-gradient);
}

@media (max-width: 1024px) {
  .cls-2 {
    fill: #516174 !important;
  }
}

.hard-block {
  fill: url(#linear-gradient-hard) !important;
  filter: grayscale(0.3);
}

.cls-2.show-seat-selected {
  fill: url(#linear-gradient-selected) !important;
  filter: grayscale(0) !important;
}
.soft-block {
  filter: grayscale(0.6);
}

.cls-3 {
  fill: #6a7a8d;
}

.cls-3.selected {
  fill: #00a1ab;
}

.cls-4 {
  fill: #a7b1bf;
}

.cls-5 {
  fill: #e1e8ec;
}

.cls-6 {
  fill: #fff;
  /* opacity: 0.75; */
}
.cls-6.pre-assigned {
  fill: #77ff77 !important;
  /* opacity: 0.75; */
}
.seat {
  position: relative;
  cursor: pointer;
}
.isSeat {
  position: relative;
}

span.seatAttr {
  position: absolute;
  left: 0;
  right: 0;
  color: white;
  font-size: 0.7rem;
  font-weight: 500;
  top: 4px;
}

span.seatLetter {
  position: absolute;
  z-index: 9999;
  color: white;
  font-weight: 500;
  font-size: 0.6rem;
  left: 0;
  right: 0;
  top: 5px;
}
</style>
